import React from 'react'
import '../assets/css/ButtonDonations.css';

export const ButtonDonations = ({ toggleInfo }) => {
  return (
    <button className='btn btn-donations' type='button' onClick={toggleInfo}>Donaciones</button>
  )
}
